import {
    FETCH_TODO_REQUEST,
    FETCH_TODO_SUCCESS,
    FETCH_TODO_FAILURE,
    FETCH_LANGUAGES_FAIL,
    FETCH_LANGUAGES_REQUEST,
    FETCH_LANGUAGES_SUCCESS,
    FETCH_WORDS_FAIL,
    FETCH_WORDS_SUCCESS,
    FETCH_WORDS_REQUEST,
    ADD_LANGUAGES_REQUEST,
    EDIT_WORD_REQUEST,
    ADD_WORD_REQUEST,
    EDIT_WORD_SUCCESS
} from "./actionTypes";

import { TodoActions, TodoState } from "./types";

const initialState: TodoState = {
    pending: false,
    todos: [],
    languages: [],
    words:[],
    error: null,
    message:"",
    metadata: {
        page: 1,
        limit: 20,
        total: 0,
    },
    loading: null,

};

const toTranslateReducer = (state = initialState, action: TodoActions) => {
    switch (action.type) {
        case FETCH_TODO_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case FETCH_TODO_SUCCESS:
            return {
                ...state,
                pending: false,
                todos: action.payload.todos,
                error: null,
            };
        case FETCH_TODO_FAILURE:
            return {
                ...state,
                pending: false,
                todos: [],
                error: action.payload.error,
            };
        //===================FETCH LANGUAGE===================//
        case FETCH_LANGUAGES_REQUEST:
            return{
                ...state,
                pending: true
            }
        case FETCH_LANGUAGES_SUCCESS:
            return {
                ...state,
                pending: false,
                languages: action.payload.languages,
                message:action.payload.message,
                error: null,
            };
        case FETCH_LANGUAGES_FAIL:
            return {
                ...state,
                pending: false,
                error: action.payload.error,
            };
        case ADD_LANGUAGES_REQUEST:
            return {
                ...state,
                pending: true
            };
        //===================FETCH WORD===================//
        case FETCH_WORDS_REQUEST:
            return{
                ...state,
                pending: true,
            }
        case FETCH_WORDS_SUCCESS:
            return {
                ...state,
                pending: false,
                words: action.payload.words,
                message: action.payload.message,
                metadata: action.payload.metadata,
                error: null,
                loading: null
            };
        case FETCH_WORDS_FAIL:
            return {
                ...state,
                pending: false,
                error: action.payload.error,
            };
        case EDIT_WORD_REQUEST:
            return {
                ...state,
                pending:true,
                loading: 'loading'
            }
        case EDIT_WORD_SUCCESS:
            return {
                ...state,
                loading: action.payload.loading
            }
        case ADD_WORD_REQUEST:
            return {
                ...state,
                pending: true
            }
        default:
            return {
                ...state,
            };
    }
};

export default toTranslateReducer;
